import {
  AppBar, Backdrop,
} from '@mui/material';
import styled from 'styled-components';

import { isDark } from '../../theme';

const PageContainer = styled.div`
 padding: ${({ theme }) => theme.spacing(1)};
`;

const SearchContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(4)};
`;

const AddAttendeeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledAppBar = styled(AppBar)`
  && {
    background-color: ${({ theme }) => (isDark(theme) ? theme.palette.backdrop.light : theme.palette.darkPrimary.main)};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right:${({ theme }) => theme.spacing(1)};
  padding-bottom:${({ theme }) => theme.spacing(1)};
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  width: 100%;
  height: 100%;
  position: absolute;
`;

export { AddAttendeeContainer,
  StyledBackdrop,
  ButtonContainer,
  PageContainer,
  SearchContainer,
  StyledAppBar };
